import React, { useEffect, useState } from "react";

const API =
  process.env.NODE_ENV === "production"
    ? "https://ecovanta.onrender.com"
    : "http://localhost:5000";

export default function ESGMaturityAssessmentDetail() {
  const [assessment, setAssessment] = useState(null);
  const [status, setStatus] = useState("Loading assessment report...");

  useEffect(() => {
    async function loadAssessment() {
      try {
        const id = window.location.pathname.split("/").pop();

        const response = await fetch(`${API}/maturity-assessments/${id}`);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data?.error || "Unable to load assessment.");
        }

        setAssessment(data);
        setStatus("");
      } catch (error) {
        console.error("Load assessment failed:", error);
        setStatus(`Failed to load assessment: ${error.message}`);
      }
    }

    loadAssessment();
  }, []);

  if (status) {
    return (
      <main style={{ maxWidth: "1000px", margin: "0 auto", padding: "40px 20px" }}>
        <a href="/esg-maturity-history">← Back to History</a>
        <p>{status}</p>
      </main>
    );
  }

  if (!assessment) return null;

  return (
    <main style={{ maxWidth: "1000px", margin: "0 auto", padding: "40px 20px" }}>
      <a href="/esg-maturity-history">← Back to History</a>

      <section
        style={{
          marginTop: "24px",
          padding: "30px",
          border: "2px solid #0f766e",
          borderRadius: "16px",
          background: "#ffffff"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #e5e7eb",
            paddingBottom: "16px",
            marginBottom: "24px"
          }}
        >
          <div>
            <h2 style={{ margin: 0, color: "#0f766e" }}>Ecovanta</h2>
            <p style={{ margin: "4px 0 0", color: "#64748b" }}>
              ESG Intelligence Platform
            </p>
          </div>

          <div style={{ textAlign: "right", color: "#64748b" }}>
            <strong>Saved ESG Maturity Report</strong>
            <br />
            {new Date(assessment.createdAt).toLocaleDateString()}
          </div>
        </div>

        <h1>ESG Maturity Report</h1>

        <h3>Overall Score: {assessment.overallScore}/5</h3>
        <h3>Maturity Level: {assessment.maturityLevel}</h3>

        <h2>Dimension Scores</h2>

        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "2px solid #e5e7eb" }}>
              <th align="left" style={{ padding: "12px" }}>Dimension</th>
              <th align="left" style={{ padding: "12px" }}>Score</th>
            </tr>
          </thead>

          <tbody>
            {(assessment.dimensionScores || []).map((dimension) => (
              <tr key={dimension.name} style={{ borderBottom: "1px solid #e5e7eb" }}>
                <td style={{ padding: "12px" }}>{dimension.name}</td>
                <td style={{ padding: "12px" }}>{dimension.score}/5</td>
              </tr>
            ))}
          </tbody>
        </table>

        <h2 style={{ marginTop: "32px" }}>Recommendations</h2>

        <div style={{ display: "grid", gap: "16px" }}>
          {(assessment.recommendations || []).map((item) => (
            <div
              key={item.name}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                padding: "16px",
                background: "#f8fafc"
              }}
            >
              <h3 style={{ marginTop: 0 }}>{item.name}</h3>
              <p><strong>Score:</strong> {item.score}/5</p>
              <p><strong>Priority:</strong> {item.priority}</p>
              <p>{item.recommendation}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}